import Image from '@/components/image';
import { labelPositions, validateProductImage } from '@/utils/product';

const ProductLabel = ({ label, fromCategory = false }) => {
  const settingsKey = fromCategory ? 'category_settings' : 'frontend_settings';
  const imgSrc = validateProductImage(label?.[settingsKey]?.image);

  return (
    <>
      <div
        className={` ${labelPositions(label?.[settingsKey]?.position)} `}
        // style={{
        //   ...modifyCss(label?.[settingsKey]?.style),
        //   width: `${
        //     label?.[settingsKey]?.image_size
        //       ? `${label?.[settingsKey]?.image_size}%`
        //       : 'auto'
        //   }`,
        // }}
      >
        {label?.[settingsKey]?.image && (
          <Image
            src={imgSrc}
            className='h-auto w-full object-contain'
            width={label?.[settingsKey]?.image_size || 70}
            height={label?.[settingsKey]?.image_size || 70}
            alt='Img !'
          />
        )}
        {label?.name && (
          <div className={`bg-primary rounded-md p-1 text-sm text-white`}>
            <span>{label?.name}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductLabel;
